'use client';

import { forwardRef } from 'react';

import { Icon } from '../icon/icon';
import { filterChipIconStyles } from './styles/filter-chip-icon.styles';
import type { FilterChipIconPropsInterface } from './types/filter-chip-icon.types';

/**
 * @since 10.0.0
 */
export const FilterChipIcon = forwardRef<SVGSVGElement, FilterChipIconPropsInterface>(
  (props, forwardedRef) => {
    const { children, css: cssProp, ...rest } = props;

    return (
      <Icon
        data-c11n-component="FilterChip.Icon"
        data-c11n-version={__C11N_VERSION__}
        ref={forwardedRef}
        css={{ ...filterChipIconStyles, ...cssProp }}
        {...rest}
      >
        {children}
      </Icon>
    );
  },
);

FilterChipIcon.displayName = 'FilterChip.Icon';
